import React from 'react'
import {
    List,
    Edit,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
} from 'react-admin'

export const notificationNotificationTypeEdit = ({ ...props }) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="id" />
            <TextInput source="name" />
            <TextInput source="description" />
        </SimpleForm>
    </Edit>
)

export const notificationNotificationTypeList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="description" />
            </Datagrid>
        </List>
    )
}
